import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=2d5b44a8&"
import script from "./Report.vue?vue&type=script&lang=ts&"
export * from "./Report.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports